import Millimetre from "./Millimetre";

function MillimetreBiSquared() {
  return <Millimetre exponent={4} />;
}

export default MillimetreBiSquared;
